import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { SubGroupQueries } from '@/services/groupsManagement/subGroups.queries';
import { useSearch } from '@tanstack/react-router';

export const useSubGroupsList = (groupId: string) => {
  const { page, q, fetch, locationFilter, sort } = useSearch({
    from: '/(app)/configuration-management/group-management/$sub-group/',
  });

  const { data, isLoading } = useQuery({
    ...SubGroupQueries.list({
      row: page,
      search: q ?? '',
      fetch,
      location: locationFilter,
      groupId: groupId,
    }),
    select: (res) => ({
      ...res,
      data: {
        ...res.data,
        subGroupRow: sortBy(res.data?.subGroupRow ?? [], sort),
      },
    }),
    enabled: !!groupId,
  });

  return {
    data: data?.data?.subGroupRow ?? [],
    pagination: data?.meta?.pagination || defaultMeta,
    isLoading,
    commonGroupId: data?.meta?.additionalValue?.commonGroupId,
  };
};
